import React from 'react'
import ApartmentList from '../../features/marketingExecutive/ApartmentList'

const ApartmentListMarExe = () => {
  return <ApartmentList/>
}

export default ApartmentListMarExe